//import jwtAxios from '../../@crema/services/auth/jwt-auth/jwt-api';
//import {fetchError, fetchStart, fetchSuccess} from './Common';
//import {AuthType} from '../../shared/constants/AppEnums';
//import {defaultUser} from '../../shared/constants/AppConst';
//import {Loc} from '../../types/models/Loc';
import {AppActions} from '../../types';
import {Dispatch} from 'redux';
import {
  SET_LOC,
  // UPDATE_LOC,
  //GET_CURR_LOC
} from '../../types/actions/CurrLoc.actions';

export const setCurrLoc = (id: string, name: string, state: string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch({type: SET_LOC, payload:{locid: id, locname:name, locstate: state},});
  };
};

// const getLocObject = (loc: any): Loc => {
//   return (dispatch: Dispatch<AppActions>) => {
//     dispatch({type: SET_LOC, payload:{locid: id, locname:name},});
//   };

//   return {
//     locid: loc._locid,
//     locname: loc._locname,
//   };
// };

// export const onJWTAuthSignout = () => {
//   return (dispatch: Dispatch<AppActions>) => {
//     dispatch(fetchSuccess());
//     setTimeout(() => {
//       dispatch({type: SIGNOUT_AUTH_SUCCESS});
//       dispatch(fetchSuccess());
//       localStorage.removeItem('token');
//     }, 500);
//   };
// };
